/* OKHmedia - guidede turer: live lagervisning ved siden av 'Fa pa lager',
   og fjerner 'klar for sending' (kun booking, ingen sending). Skjuler tall ved 0. */
(function(){
  if(window.__okhStockInit){return;} window.__okhStockInit=true;
  function buildMap(){
    var el=document.querySelector('.okh-stock-data');
    if(!el){return null;}
    var map={}; var parts=(el.textContent||'').split(';');
    for(var i=0;i<parts.length;i++){
      var kv=parts[i].split(':');
      if(kv.length===2){ var q=parseInt(kv[1],10); map[kv[0]]=isNaN(q)?null:q; }
    }
    var datas=document.querySelectorAll('.okh-stock-data');
    for(var j=0;j<datas.length;j++){ if(datas[j].parentElement){ datas[j].parentElement.style.display='none'; } }
    return map;
  }
  var map=buildMap();
  function curId(){
    var f=document.querySelector('form[action*="/cart/add"] [name="id"]');
    if(f&&f.value){return String(f.value);}
    var u=new URLSearchParams(location.search).get('variant');
    if(u){return String(u);}
    if(map){ var k=Object.keys(map); if(k.length){return k[0];} }
    return null;
  }
  function cleanShipping(p){
    for(var n=0;n<p.childNodes.length;n++){
      var node=p.childNodes[n];
      if(node.nodeType===3){
        var t=node.nodeValue;
        var nt=t.replace(/\s*[–—-]\s*klar for sending/i,'').replace(/klar for sending/i,'');
        if(nt!==t){ node.nodeValue=nt; }
      }
    }
  }
  function render(){
    if(!map){ map=buildMap(); if(!map){return;} }
    var id=curId();
    var qty=(id&&Object.prototype.hasOwnProperty.call(map,id))?map[id]:null;
    var ps=document.querySelectorAll('.x-block-inventory-status p');
    for(var i=0;i<ps.length;i++){
      var p=ps[i];
      cleanShipping(p);
      var ex=p.querySelector('.okh-stock-left');
      if(typeof qty==='number'&&qty>0){
        if(!ex){ ex=document.createElement('span'); ex.className='okh-stock-left'; ex.style.marginLeft='6px'; ex.style.fontWeight='600'; p.appendChild(ex); }
        ex.textContent='· '+qty+' igjen';
      } else if(ex){ ex.parentNode.removeChild(ex); }
    }
  }
  var target=document.querySelector('main')||document.body;
  var obs=null, pending=false;
  function run(){ pending=false; if(obs){obs.disconnect();} try{ render(); } finally { if(obs){ obs.observe(target,{childList:true,subtree:true}); } } }
  function schedule(){ if(pending){return;} pending=true; setTimeout(run,30); }
  try{ render(); }catch(e){}
  if(window.MutationObserver){ obs=new MutationObserver(schedule); obs.observe(target,{childList:true,subtree:true}); }
  document.addEventListener('change',schedule,true);
  document.addEventListener('click',schedule,true);
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',schedule); }
  setTimeout(render,300); setTimeout(render,1200);
})();
